import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SharedLayoutsService {
    constructor() {}

    getStyles(padding: any): { [key: string]: string } {
        const styles: { [key: string]: string } = {};

        if (!padding) {
            return styles;
        }

        ['top', 'bottom', 'left', 'right'].forEach(side => {
            if (padding[side]) {
                const propertyPrefix = 'margin';
                styles[
                    `${propertyPrefix}${side
                        .charAt(0)
                        .toUpperCase()}${side.slice(1)}`
                ] = `${padding[side]}px`;
            }
        });

        return styles;
    }
}
